import React from "react";
import InternalLinkBio from "./InternalLinkBio/InternalLinkBio";
import ExternalLinkBio from "./ExternalLinkBio/ExternalLinkBio";

const BUTTON_COMPONENTS = {
  internal_link_button: InternalLinkBio,
  external_link_button: ExternalLinkBio,
};

const MainBtnLinkBio = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { version } = objinfo || {};

  const ButtonComponent = BUTTON_COMPONENTS[version];

  if (!ButtonComponent) return null;

  return <ButtonComponent options={options} />;
};

export default MainBtnLinkBio;
